import { put, select } from "redux-saga/effects";
import importer from "common/importer";
const ChatbotActions = importer("Stores/Chatbot/Actions");
// const { tokens } = importer('Stores/Users/Select', null)
export default function* main() {
  try {
    console.log("Chatbot Initial State Invoked>>");
    yield put(ChatbotActions.getChatbotResponseLoading());
    // const res = yield getChatbotResponse({ inputText });
    yield put(ChatbotActions.getChatbotInitialstate());
  } catch (error) {
    yield put(ChatbotActions.getChatbotResponseFailure(error));
  }
}
